import React, { useState, memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { TableCell } from '@mui/material';
import { ThinCheckbox } from 'components/common/Styles';

const AllowedStateUserGroup = ({ userGroup, allowedState, dispatch, changedAllowedStatesPermission }) => {
  const [checkedValue, setCheckedValue] = useState(false);

  useEffect(() => {
    const isChecked = allowedState.userGroups.filter(x => x.userGroupId === userGroup.id);
    if (isChecked && isChecked[0]) setCheckedValue(true);
    else setCheckedValue(false);
  }, [allowedState.userGroups, userGroup.id]);

  useEffect(() => {
    if (changedAllowedStatesPermission !== undefined) setCheckedValue(changedAllowedStatesPermission);
  }, [changedAllowedStatesPermission]);

  const onChangeChecked = event => {
    dispatch({
      type: 'OnChangeAllowedStatesPermission',
      allowedStateId: allowedState.id,
      userGroupId: userGroup.id,
      value: event.target.checked
    });
  };

  return (
    <TableCell padding='none' align='center' key={userGroup.userGroupId}>
      <ThinCheckbox checked={checkedValue} onChange={onChangeChecked} />
    </TableCell>
  );
};

AllowedStateUserGroup.propTypes = {
  userGroup: PropTypes.object.isRequired,
  allowedState: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  changedAllowedStatesPermission: PropTypes.bool
};

export default memo(AllowedStateUserGroup);
